let onExpiry;
let sessionTimeoutID;
const sessionTimeoutTime = 600000;
const sessionUtils = {
  appSessionManagement(expiryFunc) {
    onExpiry = expiryFunc;
    sessionTimeoutID = setTimeout(onExpiry, sessionTimeoutTime);
    document.onkeydown = this.restartInactivityTimer.bind(this);
    document.onchange = this.restartInactivityTimer.bind(this);
    document.onmousemove = this.restartInactivityTimer.bind(this);
    document.onmousedown = this.restartInactivityTimer.bind(this); // touchscreen presses
    document.ontouchstart = this.restartInactivityTimer.bind(this);
    document.ontouchmove = this.restartInactivityTimer.bind(this);
    document.ontouchend = this.restartInactivityTimer.bind(this);
    document.ontouchcancel = this.restartInactivityTimer.bind(this);
    document.onclick = this.restartInactivityTimer.bind(this); // touchpad clicks
    document.onscroll = this.restartInactivityTimer.bind(this); // scrolling with arrow keys
    document.onkeypress = this.restartInactivityTimer.bind(this);
  },
  restartInactivityTimer() {
    clearTimeout(sessionTimeoutID);
    sessionTimeoutID = setTimeout(onExpiry, sessionTimeoutTime);
  },
  returnSessionTimeoutID() {
    return sessionTimeoutID;
  },
  clearTimeOut() {
    clearTimeout(sessionTimeoutID);
  }
};

export default sessionUtils;
